<template>
  <nw-form
    :nw-form-value="form"
    @nw-form-input="handleNwFormInput"
    ref="nwForm"
  >
    <b-form-group
      id="Conscious"
      :label="$t('kiosk.conscious')"
      label-for="Conscious"
      label-cols="3"
    >
      <validation-provider
        :name="$t('kiosk.conscious')"
        rules="required"
        #default="{ errors }"
      >
        <v-select
          :value="form.Conscious"
          @input="v => { form.Conscious = v; emitFormData() }"
          label="statusDesc"
          :options="selectOptions.conscious"
          :reduce="option => option.statusCode"
          :searchable="false"
        />
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>
  </nw-form>
</template>

<script>
import nwFormTaskTypeMixin from "@/views/kiosk/components/kskNursingWork/mixins/nwFormTaskTypeMixin";
import vSelect from 'vue-select'

export default {
  name: "NwFormConscious",
  mixins: [nwFormTaskTypeMixin],
  components: {vSelect},
}
</script>

<style scoped>

</style>